import { getLocalStorage, setLocalStorage } from "../src/taskpane/components/helpers/localStorageHelper";

export class CacheHelper {
    private static readonly cache: Map<string, any> = new Map();

    static set(key: string, value: any, persist: boolean = false): boolean {
        try {
            CacheHelper.cache.set(key, value);
            if (persist) {
                setLocalStorage(key, value);
            }
            return true;
        } catch (error) {
            return false;
        }
    }

    static get(key: string, checkPersistedValue: boolean = false): any {
        try {
            let value = CacheHelper.cache.get(key);
            if ((value === undefined || value === null) && checkPersistedValue) {
                value = getLocalStorage(key);
                if (value) {
                    CacheHelper.set(key, value);
                }
            }
            return value;
        } catch (error) {
            return undefined;
        }
    }

    static remove(key: string): void {
        try {
            CacheHelper.cache.delete(key);
        } catch (error) { }
    }

    static removeByPrefix(prefix: string): void {
        try {
            for (const key of Array.from(CacheHelper.cache.keys())) {
                if (typeof key === "string" && key.startsWith(prefix)) {
                    CacheHelper.cache.delete(key);
                }
            }
        } catch (error) { }
    }
}